import { MutliPropertyContainer, LeftDetails, RightDetails } from './OfferDetailsMultiPropertySkeletonLoader.styles';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const OfferDetailsMultiPropertySkeletonLoader: React.FC<any> = () => {
  return (
    <MutliPropertyContainer>
      <div className="container mpo-wrapper">
        <LeftDetails>
          <div className="skeleton-loader heading"></div>
          <div className="skeleton-loader heading"></div>
          <div className="description-container">
            <div className="skeleton-loader offer-description"></div>
            <div className="skeleton-loader offer-description"></div>
            <div className="skeleton-loader offer-description"></div>
          </div>
          <div className="skeleton-loader sub-heading"></div>
          <div className="skeleton-loader offer-description"></div>
          <div className="skeleton-loader offer-description"></div>
          <div className="skeleton-loader offer-description"></div>
          <div className="skeleton-loader terms-and-conditions"></div>
        </LeftDetails>
        <RightDetails>
          <div className="skeleton-loader sub-heading"></div>
          <div className="skeleton-loader offer-description"></div>
          <div className="skeleton-loader offer-description"></div>
          <div className="skeleton-loader offer-description"></div>
        </RightDetails>
      </div>
    </MutliPropertyContainer>
  );
};
